import { getInfoObject } from 'utils/tokenService';
import packageJson from '../../package.json';

/**
 * Returns the pinned @thoughtspot/visual-embed-sdk version from the app's
 * package.json dependencies.
 */
export const getSdkVersion = (): string =>
  (packageJson.dependencies as Record<string, string>)['@thoughtspot/visual-embed-sdk'] || '';

/**
 * Returns the ThoughtSpot cluster (release) version from the cached preauth info
 * payload. Returns an empty string if it is unavailable.
 */
export const getClusterVersion = async (): Promise<string> => {
  const infoObject = await getInfoObject();
  return infoObject?.info?.releaseVersion || '';
};
